<script setup lang="ts">
import {computed} from 'vue';
import {useRoute} from 'vue-router';
import {useLayout} from '@/layout/composables/layout';
import {getGruposClassicos} from './menu.classico.config';
import {itemEhAtivo} from './menu.util';
import type {MenuItemFolha} from './menu.type';

const route = useRoute();
const {layoutState, onMenuToggle} = useLayout();

const grupos = computed(() => getGruposClassicos());

const ativo = (item: MenuItemFolha) => itemEhAtivo(item, route);

const aoClicarItem = (item: MenuItemFolha, event: Event) => {
    if (item.command) {
        item.command({originalEvent: event, item});
    }

    if ((item.to || item.url) && (layoutState.staticMenuMobileActive || layoutState.overlayMenuActive)) {
        onMenuToggle();
    }
};
</script>

<template>
    <ul class="layout-menu">
        <li v-for="grupo in grupos" :key="grupo.label" class="layout-root-menuitem">
            <div class="layout-menuitem-root-text">{{ grupo.label }}</div>
            <ul>
                <li v-for="item in grupo.itens" :key="item.id">
                    <router-link
                        v-if="item.to"
                        :to="item.to"
                        :class="{'active-route': ativo(item)}"
                        tabindex="0"
                        @click="aoClicarItem(item, $event)"
                    >
                        <i :class="item.icon" class="layout-menuitem-icon"></i>
                        <span class="layout-menuitem-text">{{ item.label }}</span>
                    </router-link>
                    <a v-else :href="item.url" :target="item.target" tabindex="0" @click="aoClicarItem(item, $event)">
                        <i :class="item.icon" class="layout-menuitem-icon"></i>
                        <span class="layout-menuitem-text">{{ item.label }}</span>
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</template>

<style lang="scss" scoped></style>
